const config = {
  loginUrl: process.env['BASE_PATH'],
  snUrl: process.env['SN_URL'],
  mockUrl: '/api',
  avtarImg: '/api/waf/report/upload', // 上传图片
  authImg: '/api/jvsit/uploadLicense', // 上传企业认证图片
  uploadDeal: '/api/wsc/contract/uploadContract',// 上传合同
  zipUrl: '/api/waf/zipUpload'
}
export default config



// WEBPACK FOOTER //
// ./src/jvsit/common/config.js